/**
 * Models the chart review assigment count by reviewer
 */

import Brace from "backbone.brace";
import _ from "underscore";

const BulkChartAssignment = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    count: Number,
  },

  defaults: {
    id: null,
    count: 0,
  },

  validate(attrs) {
    if (attrs.id === null) {
      return "A reviewer ID is required.";
    } else {
      if (!_.isNumber(attrs.id) || _.isNaN(attrs.id)) {
        return "A reviewer ID must be a number.";
      } else {
        if (attrs.id < 0) {
          return "A reviewer ID must be greater than 0.";
        }
      }
    }

    if (attrs.count === null) {
      return "Assigned chart count is required.";
    } else {
      if (!_.isNumber(attrs.count) || _.isNaN(attrs.count)) {
        return "Assigned chart count must be a number.";
      } else {
        if (attrs.count < 0) {
          return "Assigned chart count must be greater than 0.";
        }
      }
    }
  },
});

export { BulkChartAssignment as default };
